import React from "react";
import BaseModal from "../BaseModal";

import { generateEmojiGrid, getGameResultsIcon, getGameResultsTitle } from "../../../lib/game-helpers";
import ShareScoreButton from "../../ShareScoreButton";
import CountdownToNextPuzzle from "../../CountdownToNextPuzzle";
import { PuzzleDataContext } from "../../../providers/PuzzleDataProvider";
import { GameStatusContext } from "../../../providers/GameStatusProvider";
import OtherGamesList from "../../OtherGamesList";
import { Separator } from "../../ui/separator";

function GameWonModal({ open, submittedGuesses }) {
  const { gameData } = React.useContext(PuzzleDataContext);
  const { numMistakesUsed } = React.useContext(GameStatusContext);

  return (
    <BaseModal
      icon={getGameResultsIcon(true)}
      iconPosition="bottom"
      title={getGameResultsTitle(true, numMistakesUsed)}
      subtitle="Você ganhou, parabéns!"
      initiallyOpen={open}
      showActionButton={false}
    >
      <p>Seus palpites estão representados abaixo:</p>
      <div className="justify-center">
        {/* the whitespace: pre style makes the emoji grid appear with new lines character */}
        <span className="text-center whitespace-pre">
          {"\n"}
          {generateEmojiGrid(gameData, submittedGuesses)}
        </span>
      </div>
      <ShareScoreButton className="my-4" />
      <CountdownToNextPuzzle />
      <Separator className="my-4" />
      <OtherGamesList />
    </BaseModal>
  );
}

export default GameWonModal;
